// test1235
(1235 && 0);
